import { useState } from 'react';
import logo from '../../img/Watco_logo_Horizontal_Color.svg';
import geoLogo from '../../img/GeoConnect Logo.svg'
import "./NavBar.css";
import { Link, NavLink } from "react-router-dom";

interface iProps { }

type RoutLink = { path: string; label: string | JSX.Element };
const links: Array<RoutLink> = [
  {
    path: '/railcar-storage',
    label: 'Railcar Storage'
  },
  {
    path: '/transloading',
    label: 'Transloading, Material Handling & Storage'
  },
  {
    path: '/find-property',
    label: 'Find Property'
  },
  {
    path: '/contact-us',
    label: 'Contact Us'
  }
];

const WatcoLogo = () => (
  <a className='logo' href='https://www.watco.com/'>
    <img src={logo} alt="Watco" />
  </a>
);

interface ILinks { 
  isMobile?: boolean;
}

const Links = ({isMobile=false}: ILinks) => (
  <>
    {!isMobile && <WatcoLogo/>}
    {
      links.map((link, index) => {
        return <NavLink className={({ isActive }) => (isActive ? 'selected' : '')} to={link.path} key={index}>
          {link.label}
        </NavLink>;
      })
    }
    {isMobile && <WatcoLogo/>}
  </>
);

export default function NavBar(props: iProps) {
  const [mobileMenuExpanded, setMobileMenuExpanded] = useState(false);

  const toggleMobileMenu = (evt: any) => {
    setMobileMenuExpanded(!mobileMenuExpanded);
  }

  return (
    <>
      <header className="nav-bar">
        <nav>
          <Links/>
        </nav>
        <div className={`mobile-menu-icon ${mobileMenuExpanded ? 'active' : ''}`} onClick={toggleMobileMenu}>
          <span></span>
        </div>
        <Link to="/" className="geologo">
          <img src={geoLogo} alt="GeoConnect" />
        </Link>
      </header>
      {mobileMenuExpanded &&
        <div className='mobile-menu'>
          <nav>
            <Links isMobile/>
          </nav>
        </div>
      }
    </>
  );
}